import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Meta } from '@df/core/meta/meta';
import { ISizeName } from '@df/core/service/client';
import { BodyClassService } from '@df/ui/body-class.service';
import { DfModal } from '@df/ui/modal/df-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { UiComponent } from '@df/ui/ui.component';
import { NICmsContentComponent } from '@icms/core/content';

export namespace NVipRestrictedContentModal {
    export const BLOCK_ID = 'vip-restricted-modal';
}

@DfModal({
    id: NVipRestrictedContentModal.BLOCK_ID,
    position: (sizeId: ISizeName) => (sizeId === 'S' ? 'bottom' : undefined),
    config: (sizeId: ISizeName) => ({
        closeOnNavigation: true,
        maxWidth: sizeId === 'S' || sizeId === 'M' ? '91vw' : '455px',
        width: sizeId === 'S' || sizeId === 'M' ? '343px' : '455px',
        disableClose: true
    }),
    blockGroup: 'modals',
    priority: 20,
    reopenPolicy: NDfModal.ReopenPolicy.last,
    sizeRestriction: sizeName => ({ S: ['S', 'M'], M: ['S', 'M'], L: ['L', 'X'], X: ['L', 'X'] })[sizeName]
})
@Component({
    selector: 'vip-restricted-modal',
    templateUrl: './vip-restricted-modal.html',
    standalone: true,
    imports: [TranslationModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class VipRestrictedModalComponent extends UiComponent implements NICmsContentComponent.IComponent, OnInit {
    constructor(
        private meta: Meta,
        private bodyClassService: BodyClassService,
        private router: Router,
        private modalRef: ModalRef<any>
    ) {
        super();
    }

    ngOnInit(): void {
        this.bodyClassService.add('full-overlay', this);
        super.ngOnInit();
    }

    ngOnDestroy(): void {
        this.bodyClassService.remove('full-overlay', this);
        super.ngOnDestroy();
    }

    protected goBack(): void {
        if (this.meta.previousState) {
            window.history.back();
            return;
        }
        this.router.navigateByUrl('/');
    }

    protected close(): void {
        this.modalRef.close();
    }
}
